module.exports = __webpack_public_path__ + "img/logo-small.166d5c05.jpg";